import axiosPrivate from "../../../api/axiosPrivate";
import {
  CHATS_OF_ACCOUNT_MIGRATION,
  CUSTOMER_CLAIM_MIGRATION,
  CUSTOMER_MIGRATION,
  CUSTOMER_TRANSACTION_MIGRATION,
  JORNAL_ENTRY_MIGRATION,
  POLICY_APP_DETAILS_MIGRATION,
  POLICY_APP_RISK_MIGRATION,
  SAVINGS_APP_MIGRATION,
  STAFF_MIGRATION,
  USER_MIGRATION,
} from "../../../api/constant";

const migrateStaff = async (data) => {
  const response = await axiosPrivate.post(STAFF_MIGRATION, data);
  return response.data;
};

const migrateUser = async (data) => {
  const response = await axiosPrivate.post(USER_MIGRATION, data);
  return response.data;
};

const migrateCustomer = async (data) => {
  const response = await axiosPrivate.post(CUSTOMER_MIGRATION, data);
  return response.data;
};

const migrateCustomerTransaction = async (data) => {
  const response = await axiosPrivate.post(
    CUSTOMER_TRANSACTION_MIGRATION,
    data
  );
  return response.data;
};

const migrateCustomerClaim = async (data) => {
  const response = await axiosPrivate.post(CUSTOMER_CLAIM_MIGRATION, data);
  return response.data;
};

const migrateCustomerPolicyApp = async (data) => {
  const response = await axiosPrivate.post(POLICY_APP_DETAILS_MIGRATION, data);
  return response.data;
};

const migrateCustomerPolicyRisk = async (data) => {
  const response = await axiosPrivate.post(POLICY_APP_RISK_MIGRATION, data);
  return response.data;
};
const migrateJournal = async (data) => {
  const response = await axiosPrivate.post(JORNAL_ENTRY_MIGRATION, data);
  return response.data;
};
const migrateChartsOfAccount = async (data) => {
  const response = await axiosPrivate.post(CHATS_OF_ACCOUNT_MIGRATION, data);
  return response.data;
};
const migrateSavingsApp = async (data) => {
  const response = await axiosPrivate.post(SAVINGS_APP_MIGRATION, data);
  return response.data;
};

const migrationService = {
  migrateStaff,
  migrateUser,
  migrateCustomer,
  migrateCustomerTransaction,
  migrateCustomerClaim,
  migrateCustomerPolicyApp,
  migrateCustomerPolicyRisk,
  migrateJournal,
  migrateChartsOfAccount,
  migrateSavingsApp,
};

export default migrationService;
